import { Injectable } from '@angular/core';

import { ApiService} from '../../../core/service/api.service';

import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import {Subject} from 'rxjs/Subject';

@Injectable()
export class FileDownloadService {

    private fileDownloadSubject = new Subject<string>();

    constructor(private api: ApiService) {
    }

    downloadFile(pk: number, filename: string): Observable<ArrayBuffer> {
        const options = this.api.createOptions({});
        return this.api.getHttp().get(this.api.createUrl('file/' + pk + '/download'), {
            'headers' : options['headers'],
            'responseType' : 'arraybuffer'
        });
    }

    downloadMinioFile(typeResource: string, pkResource: number, filetype: string, filename: string): Observable<ArrayBuffer> {
        const options = this.api.createOptions({});
        const params = {
            'resource_type' : typeResource,
            'resource_pk' : pkResource,
            'file_type' : filetype,
            'filename' : filename
        };

        return this.api.getHttp().get(this.api.createUrlWithParams('file-download-minio', params), {
            'headers' : options['headers'],
            'responseType' : 'arraybuffer'
        });
    }

    getSubject(): Subject<string> {
        return this.fileDownloadSubject;
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/shared/components/file_download/file_download.service.ts